import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TRollPreProcessingChecksAndPaymentsToPendingRequestSchema,
  TRollPreProcessingChecksAndPaymentsToPendingResponseSchema,
} from "./rollPreProcessingChecksAndPaymentsToPending.schema";

const URL = "/api/rollPreProcessingChecksAndPaymentsToPending";

export const rollPreProcessingChecksAndPaymentsToPending = (
  axios: IAxiosInstance
) => {
  return async (
    data: TRollPreProcessingChecksAndPaymentsToPendingRequestSchema
  ) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TRollPreProcessingChecksAndPaymentsToPendingResponseSchema>
    >(URL, data);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
